import React from 'react';
import './styles.less';

export function StreamlineCyberMaintenance( props ) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" { ...props }>{ /* Icon from Cyber free icons by Streamline - https://creativecommons.org/licenses/by/4.0/ */ }<path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M22.5 7.5H.5v7h22zm-18 7v9m-2 0h4m12-9v9m2 0h-4m-16-9l7-7m-2 7l7-7m-2 7l7-7m-2 7l7-7M6.5 5l-2 1.5l-2-1.5V3l2-1.5l2 1.5zm14 0l-2 1.5l-2-1.5V3l2-1.5l2 1.5z" /></svg>
    );
}

// Every SEIKO domain (academy.seikovision.com, *-seiko.biwlearning-hoya.com) contains 'seiko'
const IS_SEIKO = window.location.hostname.toLowerCase().includes( 'seiko' );

const SITE_NAME = IS_SEIKO ? 'SEIKO Vision Academy' : 'Hoya Learning Center';
const SITE_ABBREVIATION = IS_SEIKO ? 'SVA' : 'HLC';

const MaintenancePage = () => {

    return (
        <main className="maintenance-overlay">
            <StreamlineCyberMaintenance className="maintenance-icon" aria-hidden="true" />
            <h1>{ SITE_NAME } ({ SITE_ABBREVIATION }) is Temporarily Unavailable</h1>
            <p>We are currently experiencing an issue affecting access to { SITE_ABBREVIATION }. Our team is working to address it and will share additional information as soon as it becomes available.
We appreciate your patience and understanding.</p>
        </main>
    );
};

export default MaintenancePage;
